export function parseErrorMsg(element, key) {
  if (element.hasAttribute('data-errors')) {
    const errorAttr = JSON.parse(element.getAttribute('data-errors'));
    return errorAttr[key];
  }

  return false;
}

export function emailValidation(email) {
  const re = /^(([^*<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
  return re.test(String(email).toLowerCase());
}

export function usernameValidation(username) {
  const usernameRegex = /^[a-zA-Z0-9._\-+]+$/;

  if (username.length < 3) {
    return 'invalid_characters';
  } if (username.length > 32) {
    return 'username_length';
  }

  if (!username.match(usernameRegex)) {
    return 'invalid_characters';
  }
  return true;
}

export function teamnameValidation(teamname) {
  if (teamname.trim() <= 0) {
    return 'field_empty_error';
  } if (teamname.length > 30) {
    return 'teamname_max_length';
  }

  return true;
}
